import * as yup from 'yup';
import { date, string } from 'yup';

export const timeOffFormValidator = yup.object({
  start: date().required('Required'),
  isOnGoing: yup.boolean().default(false),
  end: date().when('isOnGoing', {
    is: value => value,
    then: schema => schema.required('Required'),
    otherwise: schema => schema.nullable(),
  }),
  reason: string().nullable().notRequired().max(50,"Max 50 Characters"),
});
